import { transport } from '@/api/api-endpoints'
import userFriendlyEr from '@/utils/userFriendlyEr'
import { STATUS_NOT_ACTIVE } from '@/config/config'
import formBaseMixin from '@/components/form/form-base-mixin'
import region from '@/utils/region'
import { ORENBURG } from '@/config/region'
import { tkoOffline } from '@/api/api-offline-endpoints'
import { core } from '@/api/api-endpoints'
import documentsMixin from '@/common/layout/documents/documentsMixin'
import { REGION_CONFIG } from '@/config/regions'

const Okved = () => ({
  name: '',
  code: '',
})

export default {
  mixins: [formBaseMixin, documentsMixin],
  data() {
    return {
      fields: {
        name: '',
        status_id: '',
        tariffs: [],
        tkoOperatorTariffs: [],
        tkoOperatorInvests: [],
        agreement_num: '',
        agreement_from: '',
        invest_num: '',
        invest_from: '',
        invest_to: '',
        license_number: '',
        license_start_date: '',
        license_finish_date: '',
        fact_address: '',
        legal_address: '',
        short_name: '',
        ogrn: '',
        geo_lat: '',
        geo_lon: '',
        okved: new Okved(),
        kpp: '',
        inn: '',
        photo_id: null,
        head_position: '',
        head_name: '',
        head_phone: '',
        head_email: '',
        eco_position: '',
        eco_name: '',
        eco_phone: '',
        reo_id: '',
      },
      onlyUpdate: false,
      actionsTable: null,

      showModalSetRO: false,
      showModalSmallInvest: false,

      showModalRemoveROStatusConfirmation: false,

      changeInvestError: null,

      operatorStatusChangeInProgress: false,
    }
  },
  created() {
    let obj = {}
    for (let key in REGION_CONFIG.objectAssignments) {
      obj[key] = {
        desc: REGION_CONFIG.objectAssignments[key].label,
        danger: [],
        tko_action_id: REGION_CONFIG.objectAssignments[key].tko_action_id,
      }
    }
    this.actionsTable = obj
    this.fillActionTable()
  },
  computed: {
    TARIFFS() {
      return REGION_CONFIG.operatorTariffs
    },
    currentRegion() {
      return region.getCurrentRegion()
    },
    notActive() {
      return STATUS_NOT_ACTIVE
    },
    business_categories() {
      return this.$store.getters.readUrlEndpoint(
        this.getBusinessCategoriesEndpoint()
      ).business_category
    },
    tkoOperatorInvestsByYear() {
      return this.fields.tkoOperatorInvests
    },
  },
  methods: {
    cleanEditable() {
      let { tmpEndpoints } = this.getEditablesEndpointsAndUrl()
      this.$store.commit('deleteEndpoints', {
        endpoints: tmpEndpoints,
        eager: 10,
      })
      // clean data in src/app/registry/region.krasn/components/operator-objects-table
      // fix: blank data in operator/operators table on resolve navigation hook
      this.$store.commit('deleteEndpoints', {
        endpoints: [tkoOffline.objectsTable(this.$route.name)],
        eager: 15,
      })
    },
    validateOgrn(errMsg) {
      if (
        this.fields.ogrn &&
        this.fields.ogrn.length !== 13 &&
        this.fields.ogrn.length !== 15
      ) {
        errMsg += 'ОГРН должен состоять из 13 цифр, ОГРНИП - из 15 цифр'
      }
      return errMsg
    },
    onFormSavedResponse(response) {
      let {
        id,
        source = [],
        operator = [],
        regionalOperator = [],
        tkoObject = [],
      } = response.data
      this.fields.id = this.$route.params.id || id
      this.fields.source = source
      this.fields.operator = operator
      this.fields.regionalOperator = regionalOperator
      this.fields.tkoObject = tkoObject
      this.fields = Object.assign({}, this.fields)
    },
    innerUpdated() {
      if (this.fields.id) {
        this.onlyUpdate = true
        this.sendForm()
      }
    },
    updateSummary(item) {
      item.summary =
        (item.self_resources || 0) * 1 + (item.gos_resources || 0) * 1
      if (Number.isNaN(item.summary)) {
        item.summary = 'Невозможно рассчитать сумму, вводите цифры'
      }
    },
    changeInvestValidate() {
      let errors = {}
      let regDate = new RegExp('^\\d{4}-\\d{2}-\\d{2}$', 'i')
      this.formValidator.resetErrors(['invest_from', 'invest_to'])

      if (!regDate.test(this.fields.invest_from)) {
        errors['invest_from'] = 'Укажите дату'
      }
      if (!regDate.test(this.fields.invest_to)) {
        errors['invest_to'] = 'Укажите дату'
      }

      if (!errors['invest_from'] && !errors['invest_to']) {
        let from = this.fields.invest_from.replace(/([^\d])/gim, '')
        let to = this.fields.invest_to.replace(/([^\d])/gim, '')
        if (from >= to) {
          errors['invest_from'] =
            'Выберите дату меньше ' + this.fields.invest_to
        }
      }

      if (Object.keys(errors).length > 0) {
        this.formValidator.handleServerErrors(
          { data: { errors: errors } },
          this
        )
        return false
      }

      return true
    },
    changeInvest() {
      let investFrom = this.fields.invest_from.split('-')[0]
      let investTo = this.fields.invest_to.split('-')[0]

      let newProgram = []
      for (let y = investFrom; y <= investTo; y++) {
        let exist = false
        if (this.fields.tkoOperatorInvests) {
          for (let key in this.fields.tkoOperatorInvests) {
            if (this.fields.tkoOperatorInvests[key].year == y) {
              exist = this.fields.tkoOperatorInvests[key]
            }
          }
        }
        if (exist) {
          newProgram.push(exist)
        } else {
          newProgram.push({
            self_resources: '',
            gos_resources: '',
            total: '',
            year: y,
          })
        }
      }

      this.showModalSmallInvest = false
      this.fields.tkoOperatorInvests = newProgram
    },
    getTariffsArr() {
      return this.$refs.tkoTariff.getTariffsArr()
    },
    getInvestsArr() {
      let tmp = []
      for (let key in this.tkoOperatorInvestsByYear) {
        tmp.push(this.tkoOperatorInvestsByYear[key])
      }
      return tmp
    },
    parseActions() {
      let actionWithData = []
      for (let key in this.actionsTable) {
        let element = this.actionsTable[key]

        if (element.danger.length > 0) {
          actionWithData.push({
            tko_action_id: element.tko_action_id,
            danger: element.danger,
          })
        }
      }

      return actionWithData
    },
    createEmptyActions() {
      let actionCount = 7
      let actions = []

      for (let i = 0; i < actionCount; i++) {
        actions.push({
          action_id: i + 1,
          danger: [],
        })
      }

      this.fields.actions = actions
    },
    fillActionTable() {
      if (this.fields.actions) {
        for (let i = 0; i < this.fields.actions.length; i++) {
          let element = this.fields.actions[i]

          for (let key in this.actionsTable) {
            if (
              this.actionsTable[key] &&
              +this.actionsTable[key].tko_action_id === +element.tko_action_id
            ) {
              this.actionsTable[key].danger = element.danger
            }
          }
        }
      }
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        if (this.fields.okved !== 'object') {
          console.warn(
            'Unknown format of okved, okved was reseted',
            this.fields.okved
          )
          this.fields.okved = new Okved()
        }
        this.fields = Object.assign(
          {
            tkoOperatorInvests: [],
            tkoOperatorTariffs: [],
            invests: [],
            tariffs: [],
          },
          this.fields
        )
      }
      this.update()
    },
    update() {
      if (this.item) {
        this.fillActionTable()
      } else {
        this.createEmptyActions()
      }
    },
    transformFieldsBeforeSend() {
      if (this.fields.districts) {
        delete this.fields.districts
      }
      this.fields.inn = `${this.fields.inn || ''}`

      this.fields.tariffs = this.getTariffsArr()
      this.fields.invests = this.getInvestsArr()
      this.fields.actions = this.parseActions()
    },
    getEditablesEndpointsAndUrl() {
      let postUrl = []
      let tmpEndpoints = []

      if (region.getCurrentRegion() === ORENBURG) {
        // add transport table
        postUrl.push(transport.transportCarUpdateOrCreate())
        tmpEndpoints.push(tkoOffline.operatorTransportTable(this.$route.name))
      } else {
        tmpEndpoints.push(tkoOffline.operatorTransportTable(this.$route.name))
        tmpEndpoints.push(
          tkoOffline.operatorTransportMaintenanceTable(this.$route.name)
        )
      }

      return { postUrl, tmpEndpoints }
    },
    afterSave: async function () {
      let errors = []
      // uncomment for enable multiupoder
      /* try {
        if (this.$refs.fileUploader) {
          await this.$refs.fileUploader.uploadFiles(this.fields.id)
        }
      } catch (e) {
        errors.push('Ошибка загрузки файла: ' + e.toString())
      } */

      if (!this.$route.params.id) {
        let storeUUIDIdMap = {}
        let { postUrl, tmpEndpoints } = this.getEditablesEndpointsAndUrl()

        for (let i = 0; i < tmpEndpoints.length; i++) {
          if (this.$store.getters.readUrlEndpoint(tmpEndpoints[i])) {
            let data = this.$store.getters.readUrlEndpoint(tmpEndpoints[i]).data
            for (let j = 0; j < data.length; j++) {
              if (
                data[j]._isValid === true &&
                data[j]._considerSaved === true
              ) {
                // for save transport table
                data[j].tko_operator_id = this.fields.id
                data[j].sourceId = this.fields.id
                // for transport-maintenance-table
                if (data[j].hasOwnProperty('parentId')) {
                  data[j].parentId = storeUUIDIdMap[data[j].parentId] || null
                }
                data[j].operatorName = this.fields.name
                try {
                  // get main item id
                  let {
                    data: { id },
                  } = await this.$store.dispatch('createModel', {
                    url: postUrl[i],
                    endpoint: tmpEndpoints[i],
                    data: data[j],
                  })
                  // save id in map
                  storeUUIDIdMap[data[j]._storeUUID] = id
                } catch (e) {
                  console.error(e)
                  errors.push(userFriendlyEr.recognize(e))
                }
              } else {
                console.warn('Invalid row', data[j])
              }
            }
          }
        }

        try {
          // save operator-objects-table
          await this.$refs.operatorObjectsTable.saveAllRows()
          this.$store.commit('deleteEndpoints', {
            endpoints: [tkoOffline.objectsTable(this.$route.name)],
            eager: 10,
          })
        } catch (e) {
          console.error('operator-objects-table', e)
          errors.push(e)
        }
      }

      if (errors.length > 0) {
        return Promise.reject(errors.join('<br><br>'))
      }

      return Promise.resolve(1)
    },
    openSetRO() {
      this.showModalSetRO = true
      this.operatorStatusChangeInProgress = true
    },
    openUnsetRO() {
      this.showModalRemoveROStatusConfirmation = true
      this.operatorStatusChangeInProgress = true
    },
    setROStatus() {
      this.showModalSetRO = false
      this.transformFieldsBeforeSend()
      let { hasError } = this.formValidator.validate(this)
      if (!hasError) {
        this.onlyUpdate = false
        this.fields.is_regional = true
        this.sendForm()
      }
    },
    unsetROStatus() {
      this.showModalRemoveROStatusConfirmation = false
      this.transformFieldsBeforeSend()
      let { hasError } = this.formValidator.validate(this)
      if (!hasError) {
        this.onlyUpdate = false
        this.fields.is_regional = false
        this.sendForm()
      }
    },
    cancelChangeStatus() {
      this.showModalRemoveROStatusConfirmation = false
      this.showModalSetRO = false
      this.operatorStatusChangeInProgress = false
    },
    onSuccess() {
      let route = this.getRedirectParams()
      let msg = this.$route.params.id ? 'Данные обновлены' : 'Запись сохранена'
      if (!this.fields.id) {
        delete route.query.q
      }
      if (this.operatorStatusChangeInProgress) {
        route.query.q = this.fields.inn
        msg = 'Статус оператора изменен'
      }
      route.name = this.fields.is_regional
        ? 'registry.regionalOperators'
        : 'registry.operators'
      this.unFreezeFrom()
      this.onSaveForm()
      if (this.onlyUpdate === true) {
        this.onlyUpdate = false
        this.showOnSuccess(msg)
        // fix: stop bar after municipalities table updated
        this.$bar.finish()
      } else {
        this.showOnSuccess(msg)
        setTimeout(() => {
          this.$router.push(route)
        }, 0)
      }
    },
    fileUploaded({ id }) {
      this.fields.license_file_id = id
    },
    fileRemoved() {
      this.fields.license_file_id = null
    },
    photoUploaded({ id }) {
      this.fields.photo_id = id
    },
    photoRemoved() {
      this.fields.photo_id = null
    },
    uploadUrl() {
      return core.file()
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getItemEndpoint(route, fromRoute),
        })
      )
    }

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getBusinessCategoriesEndpoint(),
        fromCache: true,
      })
    )
    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true,
      })
    )

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  },
}
